import Vue from 'vue'
const HelperString = {};

/**
 * Limpa a string para comparações
 * @param
 *   Vaga de vendedor Temporário
 * @return
 *  vaga de vendedor temporario
 */
function slugify(_text) {
  let text = _text.toString();
  const from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
  const to = "aaaaaeeeeeiiiiooooouuuunc------";

  for (let i = 0, len = from.length; i < len; i += 1) {
    text = text.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
  }

  return text
    .toString() // Cast to string
    .toLowerCase() // Convert the string to lowercase letters
    .trim() // Remove whitespace from both sides of a string
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/&/g, "-y-") // Replace & with 'and'
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-"); // Replace multiple - with single -
}

HelperString.cleanStringToCompare = (_str) => {
  if (!_str) return "";
  const str = _str.toString();
  return slugify(str.toLowerCase()).replace(/-/g, " ");
};

HelperString.removeAccents = (str) => {
  if (!str) return "";
  let text = str.toString();
  const from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
  const to = "aaaaaeeeeeiiiiooooouuuunc------";

  for (let i = 0, len = from.length; i < len; i += 1) {
    text = text.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
  }

  return text;
};

/**
 * Formata títulos mantendo a primeira letra maiúscula DESDE QUE a palavra tenha 2 ou mais letras
 * @param
 *   VAGA de vendedor Temporário
 * @return
 *  Vaga de Vendedor Temporário
 */
HelperString.toTitle = (_str) => {
  if (!_str) return "";
  const str = _str.toString().toLowerCase().split(" ");

  const wordsToTransform = str.map((word) => {
    if (word.length >= 3) {
      return word.replace(/^\w/, (l) => l.toUpperCase());
    }
    return word;
  });

  return wordsToTransform.join(" ");
};

/**
 * Valida se string passada é um e-mail válido
 * @return
 *  true | false
 */
HelperString.isEmail = (str) => {
  if (
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
      str
    )
  ) {
    return true;
  }
  return false;
};

/**
 * Valida se string é uma senha aceita pela api
 * @return
 *  true | false
 */
HelperString.validPassword = (password) => {
  if (password.length >= 8) {
    return true;
  }
  return false;
};

/**
 * Valida se string passada é um cpf válido
 * @return
 *  true | false
 */
HelperString.isCPF = (_cpf) => {
  const cpf = _cpf.replace(/[^\d]+/g, "");
  if (cpf == "") return false;

  if (
    cpf.length !== 11 ||
    cpf == "00000000000" ||
    cpf == "11111111111" ||
    cpf == "22222222222" ||
    cpf == "33333333333" ||
    cpf == "44444444444" ||
    cpf == "55555555555" ||
    cpf == "66666666666" ||
    cpf == "77777777777" ||
    cpf == "88888888888" ||
    cpf == "99999999999"
  ) {
    return false;
  }
  let add = 0;
  for (let i = 0; i < 9; i += 1) {
    add += parseInt(cpf.charAt(i), 10) * (10 - i);
  }
  let rev = 11 - (add % 11);
  if (rev == 10 || rev == 11) {
    rev = 0;
  }
  if (rev !== parseInt(cpf.charAt(9), 10)) {
    return false;
  }
  add = 0;
  for (let i = 0; i < 10; i += 1) {
    add += parseInt(cpf.charAt(i), 10) * (11 - i);
  }
  rev = 11 - (add % 11);
  if (rev == 10 || rev == 11) {
    rev = 0;
  }
  if (rev !== parseInt(cpf.charAt(10), 10)) {
    return false;
  }
  return true;
};

/**
 * Ordera um array de objetos pela propriedade name
 * @return
 *  []
 */
HelperString.sortBy = (_array, field, order) => {
  if (!order || order == "asc") {
    return _array.slice().sort((a, b) => (a[field] > b[field] ? 1 : -1));
  }
  return _array.slice().sort((a, b) => (a[field] < b[field] ? 1 : -1));
};

/**
 * Esconde caracteres de email
 * @return
 *  []
 */
HelperString.censorEmail = (email) => {
  const hide = email.split("@")[0].length - 2;
  const r = new RegExp(`.{${hide}}@`, "g");
  const maskedEmail = email.replace(r, "***@");
  return maskedEmail;
};

/**
 * Esconde caracteres do telefone
 * @return
 *  []
 */
HelperString.censorPhone = (string) => {
  const phone = string || "";
  let newPhone = "";
  const showLatest = 2;
  for (let i = 0; i <= phone.length; i += 1) {
    if (phone[i]) {
      // eslint-disable-next-line no-restricted-globals
      if (i <= phone.length - 1 - showLatest && !isNaN(phone[i])) {
        newPhone += "*";
      } else {
        newPhone += phone[i];
      }
    }
  }

  return newPhone;
};

/*
 * Validação de número de celular (BR)
 */
HelperString.phoneBRIsValid = (string) => {
  const phone = string.replace(/[^0-9]/g, "");
  // eslint-disable-next-line prefer-regex-literals
  const regexPhone = new RegExp(
    /^(?:[14689][1-9]|2[12478]|3[1234578]|5[1345]|7[134579]) ?(?:9[1-9])[0-9]{3}[0-9]{4}/g
  );

  return !!phone.match(regexPhone);
};

/**
 * Verifica se todos os caracteres são os mesmos, exemplo: 999999
 * @return
 *  []
 */
HelperString.allCharactersSame = (s) => {
  const n = s.length;
  for (let i = 1; i < n; i += 1) {
    if (s[i] !== s[0]) return false;
  }

  return true;
};

/**
 * Remove alguns caracteres antes de enviar para a api
 * @return
 *  []
 */
HelperString.removeSomeCaracters = (o) => {
  Object.keys(o).forEach((k) => {
    if (o[k] !== null && typeof o[k] == "object") {
      HelperString.removeSomeCaracters(o[k]);
      return;
    }
    if (typeof o[k] == "string") {
      o[k] = o[k].replace(/\\|"/g, "")
    }
  });

  return o;
};

/**
 * Substitui keys camelCase to snack_case de um object
 * @return
 *  []
 */
HelperString.replaceCamelToSnakCase = (obj) => {
  Object.keys(obj).forEach((key) => {
    const newKey = key.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
    obj[newKey] = obj[key];

    if (obj[newKey] && typeof obj[newKey] == 'object') {
      obj[newKey] = Vue.prototype.$helpers.replaceCamelToSnakCase(obj[newKey]);
    }
  });

  return obj;
};

export default {
  install(Vue) {
    Object.defineProperty(Vue.prototype, "$helpers", { value: HelperString });
  },
};
